export enum SpecialLocationtype {
    China = 7,
    Japan = 6,
    WorldWide = 13,
}